module.exports = "https://www.gc-pro.gnp.com.mx/3f38b5115484c22f74cfe8333732d011.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-invitacion.svg
// module id = 1832
// module chunks = 0